export default __webpack_public_path__ + "details-pane-bg.png";